function isJSON(str) {
    try {
        JSON.parse(str);
    }
    catch (e) {
        return false;
    }
    return true;
}

export function handleFirstResponse(response) {
    if (typeof response === 'string') {
        if (isJSON(response)) {
            return JSON.parse(response);
        }
        else return({ errors: response });
    }
    else {
        let statusCode = response.status;

        switch(statusCode) {
            case 200:
            case 201:
            case 422:
            case 403:
            {
                return response.json();
            }
            case 204:
            case 205:
            {
                return({});
            }
            case 401:
            {
                return({ errors: 'Your account session has expired, please log out and log in again.' });
            }
            case 404:
            {
                return({ errors: '404' });
            }
            default: return({ errors: response });
        }
    }
}

export function getMetaData(response) {
    if (response['meta']) {
        return({
            data: response.data || [],
            currentPage: response['meta']['current_page'],
            lastPage: response['meta']['last_page'],
            totalResult: response['meta']['total']
        });
    }
    else {
        return({
            data: response.data || [],
            currentPage: response['current_page'],
            lastPage: response['last_page'],
            totalResult: response['total']
        });
    }
}
